import { useState } from "react";
import { Link } from "react-router-dom";

const AgreementCheckbox = ({ className, onChange, onClickLink = () => { } }) => {
    const [checked, setChecked] = useState(false);

    const handleChange = () => {
        const newValue = !checked;
        setChecked(newValue);
        if (onChange) onChange(newValue);
    };

    return (
        <label className={`tw-relative tw-flex tw-items-center tw-gap-2 tw-cursor-pointer tw-select-none tw-m-auto ${className}`}>
            <input
                type="checkbox"
                checked={checked}
                onChange={handleChange}
                className="tw-w-4 tw-h-4 tw-border tw-border-gray-400 tw-rounded-sm tw-cursor-pointer tw-accent-[#549A9C]"
            />
            <span className="tw-text-sm tw-text-[#282828] tw-leading-[140%]">
                I agree to the{" "}
                <Link to="/termsAndConditions" href="/terms" className="tw-text-[#549A9C] hover:tw-underline"
                    onClick={onClickLink}
                >
                    Terms of Service
                </Link>{" "}
                and{" "}
                <Link to="/privacy-policy" className="tw-text-[#549A9C] hover:tw-underline"
                    onClick={onClickLink}>
                    Privacy Policy
                </Link>
            </span>
        </label>
    );
};

export default AgreementCheckbox;
